<template>
  <!-- 费用设置 -->
  <div class="commission-related-config">
    <div class="top-title-box">
      <i class="iconfont iconyongjinshuai"></i>
      <div class="title-text">
        <div class="title-box">费率小数位配置</div>
        <span class="text">服务费率乘以费率比可能会出现小数，您可以设置保留百分号前小数的位数和取值规则</span>
      </div>
    </div>

    <div class="label-value-box">
      <div class="label-text">
        <span class="mark">*</span>
        <span class="label">保留小位数</span>
        <span class="tips">保留0位小数：百分号前小数位全部舍弃，保留1位小数:百分号前小数位保留一位，保留两位小数:百分号前小数位保留两位</span>
      </div>
      <RadioGroup v-model="formData.decimalPlaces" class="radio-group" @on-change="changeSubmit">
        <Radio label="0">0位</Radio>
        <Radio label="1">1位</Radio>
        <Radio label="2">2位</Radio>
      </RadioGroup>
    </div>

    <div class="label-value-box" v-if="formData.decimalPlaces !='0'">
      <div class="label-text">
        <span class="mark">*</span>
        <span class="label">小数位取值</span>
      </div>
      <RadioGroup v-model="formData.roundingValue" class="radio-group" @on-change="changeSubmit">
        <Radio label="0">无特别约定，根据保留小数位自动舍弃后面位数</Radio>
        <Radio label="5">小数位最后一位向下取0或者5</Radio>
      </RadioGroup>
    </div>

    <div class="line"></div>

    <div class="text-box">
      <div class="text-box-item">
        <p>举例 (无特别约定，根据保留小数位自动舍弃后面位数)</p>
        <span>1、如果选择保留1位小数，服务费率<span class="text-color">【58.666%】</span>调整为<span class="text-color">【58.6%】</span></span>
        <span>2、如果选择保留2位小数，服务费率<span class="text-color">【58.666%】</span>调整为<span class="text-color">【58.66%】</span></span>
      </div>
      <div class="text-box-item">
        <p>举例 (小数位最后一位向下取0或者5)</p>
        <span>1、如果选择保留1位小数，服务费率<span class="text-color">【58.666%】</span>调整为<span class="text-color">【58.5%】</span>，服务费率<span class="text-color">【58.144%】</span>调整为<span class="text-color">【58.0%】</span></span>
        <span>2、如果选择保留2位小数，服务费率<span class="text-color">【58.666%】</span>调整为<span class="text-color">【58.65%】</span>，服务费率<span class="text-color">【58.144%】</span>调整为<span class="text-color">【58.10%】</span></span>
      </div>
    </div>
    <div class="last-text">
      <span class="mark">*</span>
      保留0位小数，百分号前将不存在小数位，服务费率<span class="text-color">【58.666%】</span>调整为<span class="text-color">【58%】</span>~
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      formData: {}
    };
  },

  created() {
    this.getConfigData();
  },

  methods: {
    getConfigData() {
      this.$http({
        url: '/buz/commissionDecimalConfig/getConfig ',
        type: 'GET'
      }).then(res => {
        this.formData = res.data;
      });
    },

    changeSubmit() {
      let data = {};
      if (this.formData.decimalPlaces == '0') {
        data = {
          decimalPlaces: this.formData.decimalPlaces, //保留小数位
          id: this.formData.id
        };
      }
      if (this.formData.decimalPlaces != '0') {
        data = {
          decimalPlaces: this.formData.decimalPlaces, //保留小数位
          roundingValue: this.formData.roundingValue, //小数点取值
          id: this.formData.id
        };
      }
      this.$http({
        url: '/buz/commissionDecimalConfig/saveOrUpdate',
        type: 'POST',
        data
      }).then(() => {
        this.getConfigData();
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.commission-related-config {
  position: relative;
  .top-title-box {
    margin-top: 20px;
    height: 80px;
    display: flex;
    border-radius: 4px;
    padding: 0 20px;
    .iconfont {
      font-size: 20px;
      color: #f6a229;
    }
    .title-text {
      margin-left: 10px;
      display: flex;
      flex-direction: column;
      width: 100%;
      .ivu-switch {
        margin-right: 13vw;
      }
      .title-box {
        font-size: 20px;
        color: #6a5041;
        margin-top: 1px;
        display: flex;
        align-items: center;
        justify-content: space-between;
      }
      .text {
        font-size: 16px;
        color: #6a5041;
        margin-top: 20px;
        width: 70vw;
      }
    }
  }

  .label-value-box {
    margin-top: 30px;
    margin-left: 50px;
    .label-text {
      display: flex;
      align-items: center;
      .mark {
        color: #e3461f;
        font-size: 12px;
        margin-right: 2px;
      }
      .label {
        color: #515c6f;
        font-size: 13px;
        font-weight: bold;
        margin-right: 15px;
      }
      .tips {
        color: #9199a7;
        font-size: 12px;
      }
    }
    .radio-group {
      margin-top: 15px;
      color: #3c464f;
      font-size: 12px;
    }
    /deep/ .ivu-radio-group-item {
      margin-right: 40px;
    }
  }
  .line {
    height: 1px;
    width: calc(100% - 100px);
    background: #ECECEC;
    margin: 30px 0;
    margin-left: 50px;
  }
  .text-box {
    margin-left: 50px;
    .text-box-item {
      display: flex;
      flex-direction: column;
      margin-bottom: 15px;
      p {
        color: #515C6F;
        margin-bottom: 5px;
        font-weight: bold;
        font-size: 14px;
      }
      span {
        letter-spacing:0.5px;
        font-size: 13px;
        margin-bottom: 6px;
        color: #727C8E;
      }
      .text-color {
        color: #FF5F00;
      }
    }
  }
  .last-text {
    margin-left: 50px;
    color: #515C6F;
    font-size: 12px;
    letter-spacing:0.5px;
    .mark {
      color: #E3461F;
      font-size: 12px;
    }
    .text-color {
      color: #FF5F00;
    }
  }
}
</style>
